import { ChevronRightIcon } from '@heroicons/react/24/solid';
import type { NavLinkProps } from '@mantine/core';
import { NavLink as MantineNavLink } from '@mantine/core';

import styles from './NavLink.module.css';

export const LBNavLink = ({ onChange, ...props }: NavLinkProps) => (
  <MantineNavLink
    {...props}
    classNames={styles}
    component='button'
    rightSection={
      <ChevronRightIcon style={{ color: 'var(--base-dark-2)' }} width={24} />
    }
  />
);
